<div class="d-flex align-items-stretch auth auth-img-bg h-100">
  <div class="row flex-grow w-100 p-0 m-0">
      <div class="col-lg-6 d-flex align-items-center justify-content-center">
          <div class="auth-form-transparent text-left p-3" *ngIf="isLoading">
              <div class="brand-logo">
                  <img src="images/logo.svg" alt="logo">
              </div>
              <h4>Processing your consent...</h4>
              <h6 class="font-weight-light d-flex align-items-center" style="gap: 0.75rem;">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span>Please wait while we confirm your response.</span>
              </h6>
          </div>
          <div class="auth-form-transparent text-left p-3" *ngIf="!isLoading && isExpired">
              <div class="brand-logo">
                  <img src="images/logo.svg" alt="logo">
              </div>
              <h4>Oh no, this link has expired!</h4>
              <h6 class="font-weight-light">This parental consent link is no longer valid. Please ask your academy to
                  resend the consent request.</h6>
          </div>
          <div class="auth-form-transparent text-left p-3" *ngIf="!isLoading && isError">
              <div class="brand-logo">
                  <img src="images/logo.svg" alt="logo">
              </div>
              <h4>Something went wrong</h4>
              <h6 class="font-weight-light">We couldn't process your consent right now. Please refresh the page or try
                  again later. If the problem persists, contact your academy.</h6>
          </div>
          <div class="auth-form-transparent text-left p-3" *ngIf="!isLoading && !isExpired && !isError && isAccpect">
              <div class="brand-logo">
                  <img src="images/logo.svg" alt="logo">
              </div>
              <h4>Thank you!</h4>
              <h6 class="font-weight-light">Dartle thanks you for allowing us to save your child's data, be assured
                  that we will be doing our best to ensure your child data is most secure with us.
                  <br>
                  <br>
                  You can get Dartle here.
              </h6>
              <div class="mt-4 flex" style="transform: translate(-13px);">
                  <div class="flex space-x-4" style="flex-wrap: wrap;">
                    <a href="{{pwa_url}}" target="_blank" rel="noopener noreferrer" matTooltip="Get Darlte on web">
                      <img src="icons/icon-72x72.png" style="padding: 13px;border-radius: 20px;" alt="Get Dartle Community on web." class="h-12">
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=app.dartle.community.twa" target="_blank" rel="noopener noreferrer" matTooltip="Get Darlte on google app store">
                      <img src="https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png" alt="Get Dartle Community on Google Play" class="h-12">
                    </a>
                    <a href="https://apps.apple.com/app/id6744558961" target="_blank" rel="noopener noreferrer" matTooltip="Get Darlte on ios app store">
                      <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" style="padding: 13px;" alt="Download Dartle Community on App Store (US Only)" class="h-12">
                    </a>
                  </div>
              </div>
              <div *ngIf="parent_password_generated" class="mt-3 text-sm" >
                Great! It looks like you've already created your Dartle account password.
                You can proceed to the app by clicking the Login button.
                If you've forgotten your password, you can generate a new one by clicking the Recreate password button.
                <div class="d-flex mt-3" style="gap: 1rem;">
                  <button class="btn btn-primary flex-fill" (click)="login()" [disabled]="isProcessing">
                    <span *ngIf="!isProcessing">Login</span>
                    <span *ngIf="isProcessing" class="d-flex align-items-center justify-content-center" style="gap: 0.5rem;">
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      <span>Loading...</span>
                    </span>
                  </button>
                  <button class="btn btn-primary flex-fill" (click)="goToPasswordGen()" [disabled]="isProcessing">
                    <span *ngIf="!isProcessing">Recreate password</span>
                    <span *ngIf="isProcessing" class="d-flex align-items-center justify-content-center" style="gap: 0.5rem;">
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      <span>Loading...</span>
                    </span>
                  </button>
                </div>
              </div>
          </div>
          <div class="auth-form-transparent text-left p-3" *ngIf="!isLoading && !isExpired && !isError && isReject">
              <div class="brand-logo">
                  <img src="images/logo.svg" alt="logo">
              </div>
              <h4>Oh.....</h4>
              <h6 class="font-weight-light">Sorry, but for your child to attend your choosen Academy we need to save
                  some personal data.
                  <br>And you have choosen to disagree with our privacy policy.<br>
                  Nevertheless you can request again if you change your mind.
                  <br>
                  <br>
                  You can see our privay policy <a href="https://dartle.app/privacy-policy.pdf"
                      style="color: #F36A3C;" target="_blank">here.</a>
              </h6>
          </div>
      </div>
      <div class="col-lg-6 forgot-reset-half-bg d-flex flex-row">
      </div>
  </div>
</div>
